export default __webpack_public_path__ + "static/media/DieselEWPremium.5f4b9605.svg";